import { VFC } from "react";

import classNames from "classnames";

type ScrollableGridLayoutProps = {
  leftContent: JSX.Element;
  rightContent: JSX.Element;
};

/** Grid layout with 2 columns (span 2 left / span 1 right). Both columns are scrollable. Responsive to 1 column on mobile */
const ScrollableGridLayout: VFC<ScrollableGridLayoutProps> = ({ leftContent, rightContent }) => (
  <div className={classNames("flex flex-col overflow-hidden")}>
    <div
      className={classNames(
        "overflow-y-auto",
        "p-4 flex flex-col gap-y-5",
        "landscape:lg:overflow-hidden",
        "landscape:lg:grid landscape:lg:gap-x-4 landscape:lg:gap-y-0",
        "landscape:lg:grid-rows-[1fr] landscape:lg:h-full",
        "landscape:lg:grid-cols-3",
        "landscape:xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(550px,1fr)]"
      )}
    >
      {/* Left Content */}
      <div
        style={{ scrollbarWidth: "thin" }}
        className={classNames(
          "overflow-y-visible",
          "landscape:lg:col-span-2",
          "landscape:lg:overflow-y-auto landscape:lg:overflow-x-hidden"
        )}
      >
        <div className={classNames("mx-0.5", "w-full")}>{leftContent}</div>
      </div>

      {/* Right Content */}
      <div
        style={{ scrollbarWidth: "thin" }}
        className={classNames("flex", "landscape:lg:col-span-1", "landscape:lg:overflow-y-auto")}
      >
        <div className="flex w-full">{rightContent}</div>
      </div>
    </div>
  </div>
);

export default ScrollableGridLayout;
